/*
 * Shared email gate for the free tools.
 *
 * A tool computes its result, then hands it over:
 *   window.ToolGate.show(sectionId, { title, html, preview })
 * The result is held behind an email form. On submit we subscribe the address
 * to the Shopify customer list and reveal the result, discount code and
 * product picks.
 *
 * The form submits natively, not over fetch. This store has Shopify's CAPTCHA
 * enabled on customer forms, and an AJAX POST to /contact is rejected with
 * "Missing CAPTCHA token" — which fails silently, so the visitor gets their
 * result and we capture nothing. Instead the result is parked in
 * sessionStorage, the page navigates, and Shopify returns to it with
 * ?customer_posted=true, at which point the gate reveals what it parked.
 */
(function () {
  'use strict';

  var EMAIL_KEY = 'hf_tool_gate_email';
  var PENDING_PREFIX = 'hf_tool_gate_pending:';
  var PENDING_EMAIL = 'hf_tool_gate_pending_email';

  function readStore(store, key) {
    try {
      return window[store].getItem(key);
    } catch (e) {
      return null; // ponytail: Safari private mode throws; the gate just re-asks.
    }
  }

  function writeStore(store, key, value) {
    try {
      window[store].setItem(key, value);
    } catch (e) {
      /* not fatal — the visitor is asked again next time */
    }
  }

  function track(event, gateId) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: event, tool_gate_id: gateId });
  }

  function reveal(gate, result) {
    var titleEl = gate.querySelector('[data-gate-result-title]');
    var bodyEl = gate.querySelector('[data-gate-result-body]');
    if (titleEl) titleEl.textContent = result.title || '';
    // Result HTML is built by our own tool sections from sanitised inputs,
    // never pasted in raw by a visitor.
    if (bodyEl) bodyEl.innerHTML = result.html || '';

    gate.querySelector('[data-gate-lock]').hidden = true;
    var revealEl = gate.querySelector('[data-gate-reveal]');
    revealEl.hidden = false;
    return revealEl;
  }

  function bindCopy(gate) {
    var codeBtn = gate.querySelector('[data-gate-code]');
    if (!codeBtn) return;
    codeBtn.addEventListener('click', function () {
      var label = codeBtn.querySelector('[data-gate-code-label]');
      navigator.clipboard.writeText(codeBtn.getAttribute('data-gate-code')).then(function () {
        if (!label) return;
        label.textContent = 'Copied';
        setTimeout(function () {
          label.textContent = 'Copy';
        }, 2000);
      });
    });
  }

  var pending = {};

  function bindGate(gate) {
    var gateId = gate.getAttribute('data-gate-id');
    var form = gate.querySelector('.tool-gate__form');
    if (!form) return;

    var input = form.querySelector('input[type="email"]');
    var errorEl = form.querySelector('[data-gate-error]');

    bindCopy(gate);

    // Let Shopify's own submit (and its CAPTCHA) run — only block a bad address.
    form.addEventListener('submit', function (event) {
      var email = input.value.trim();

      if (!input.checkValidity() || !email) {
        event.preventDefault();
        errorEl.textContent = 'Please enter a valid email address.';
        errorEl.hidden = false;
        input.focus();
        return;
      }

      // Park the result so it survives the round trip through /contact.
      var result = pending[gateId];
      if (result) {
        writeStore('sessionStorage', PENDING_PREFIX + gateId, JSON.stringify(result));
      }
      writeStore('sessionStorage', PENDING_EMAIL, email);
      track('tool_gate_submit', gateId);
    });

    // Coming back from a successful subscribe.
    var posted = gate.querySelector('[data-gate-posted]') ||
      window.location.search.indexOf('customer_posted=true') !== -1;

    if (posted) {
      var email = readStore('sessionStorage', PENDING_EMAIL);
      if (email) writeStore('localStorage', EMAIL_KEY, email);

      var stored = readStore('sessionStorage', PENDING_PREFIX + gateId);
      if (stored) {
        try {
          var result = JSON.parse(stored);
          pending[gateId] = result;
          track('tool_gate_unlock', gateId);
          reveal(gate, result).scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) {
          /* nothing parked — the visitor can re-run the tool, which now
             reveals immediately because the email is remembered */
        }
      }
    }
  }

  window.ToolGate = {
    show: function (gateId, result) {
      var gate = document.getElementById('ToolGate-' + gateId);
      if (!gate) return;

      pending[gateId] = result;
      track('tool_result_ready', gateId);

      if (readStore('localStorage', EMAIL_KEY)) {
        track('tool_gate_unlock', gateId);
        reveal(gate, result).scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      var preview = gate.querySelector('[data-gate-preview]');
      if (preview) preview.textContent = result.preview || '';

      var lock = gate.querySelector('[data-gate-lock]');
      lock.hidden = false;
      gate.querySelector('[data-gate-reveal]').hidden = true;
      lock.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  document.querySelectorAll('[data-tool-gate]').forEach(bindGate);
})();
